import { render, staticRenderFns } from "./OpenHousePromos.vue?vue&type=template&id=752cdbfc&"
import script from "./OpenHousePromos.vue?vue&type=script&lang=js&"
export * from "./OpenHousePromos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports